import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 2,
	viewBox: "0 0 10 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1H9",
		stroke: "#F2F4F8",
		strokeWidth: 1.8,
		strokeLinecap: "round"
	})
});
export default SvgIcMinus;
